import { t } from '@/plugins/i18n'
export const columns = [
  {
    label: t('ckb订单编号'),
    prop: 'platformOrderNo',
    align: 'center'
  },
  {
    label: t('客户订单号'),
    prop: 'customerOrderNo',
    align: 'center'
  },
  {
    label: t('商品总额'),
    prop: 'productPaymentFreezeAmount',
    align: 'center',
    slotName: 'productPaymentFreezeAmount'

  },
  {
    label: t('附加项总额'),
    prop: 'productAdditionFreezeAmount',
    align: 'center',
    slotName: 'productAdditionFreezeAmount'
  },
  {
    label: t('总计'),
    prop: 'totalFreezeAmount',
    align: 'center',
    slotName: 'totalFreezeAmount'
  }
]
export const choiceColumns = [
  {
    label: t('ckb订单编号'),
    prop: 'platformOrderNo',
    align: 'center'
  },
  {
    label: t('客户订单号'),
    prop: 'customerOrderNo',
    align: 'center'
  },
  {
    label: t('运输方式'),
    prop: 'transportType',
    align: 'center',
    slotName: 'transportType'
  },
  {
    label: t('总计'),
    prop: 'totalFreezeAmount',
    align: 'center',
    slotName: 'totalFreezeAmount'
  }
]
export const childColumns = [
  {
    label: t('图片'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'productSkuImg',
    width: 100
  },
  {
    label: t('商品名称'),
    prop: 'productTitle',
    align: 'center'
  },
  {
    label: t('商品属性'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('可用库存/采购数量'),
    prop: 'frezeeQuantity',
    align: 'center',
    slotName: 'frezeeQuantity'
  },
  {
    label: t('单价'),
    prop: 'actualPrice',
    align: 'center',
    slotName: 'actualPrice'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionList',
    align: 'center',
    slotName: 'platformOrderItemAdditionList'
  },
  {
    label: t('附加项金额'),
    prop: 'productAdditionFreezeAmount',
    align: 'center',
    slotName: 'productAdditionFreezeAmount'
  },
  {
    label: t('小计'),
    prop: 'totalFreezeAmount',
    align: 'center',
    slotName: 'totalFreezeAmount'
  }
]

export const choiceChildColumns = [
  {
    label: t('图片'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'productSkuImg',
    width: 100
  },
  {
    label: t('商品名称'),
    prop: 'productTitle',
    align: 'center'
  },
  {
    label: t('商品属性'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('全包单价'),
    prop: 'allIncludeProductPrice',
    align: 'center',
    slotName: 'allIncludeProductPrice'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionList',
    align: 'center',
    slotName: 'platformOrderItemAdditionList'
  },
  {
    label: t('小计'),
    prop: 'totalFreezeAmount',
    align: 'center',
    slotName: 'totalFreezeAmount'
  }
]